import { render, staticRenderFns } from "./PurchaseOne.vue?vue&type=template&id=04558550&scoped=true&"
import script from "./PurchaseOne.vue?vue&type=script&lang=js&"
export * from "./PurchaseOne.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOne.vue?vue&type=style&index=0&id=04558550&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04558550",
  null
  
)

export default component.exports